<template>
  <div class="slotTable">
    <div v-if="update.updateModel.type==0" class="layout">
      <el-form>
        <el-form-item label="每次抽奖消耗">
          <el-input v-model="update.col.data.eachConsumption"></el-input>
        </el-form-item>
        <el-form-item label="最多可抽奖">
          <el-input v-model="update.col.data.maxQuantity"></el-input>
        </el-form-item>
        <el-form-item label="奖励设置">
          <el-button type="primary" size="small" @click="addData">增加奖励</el-button>
          <el-button type="primary" size="small" @click="delData">删除奖励</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <div class="item">
          <ul>
            <li v-for="item in nav" :style="{'width':100/nav.length+'%'}"><p>{{ item.name }}</p></li>
          </ul>
        </div>
        <div class="item" v-if="update.col.data.probability">
          <ul v-for="(item,index) in update.col.data.probability[0].percents">
            <li :style="{'width':100/nav.length+'%'}"><p>{{ index + 1 }}</p></li>
            <li :style="{'width':100/nav.length+'%'}">
              <inputDiv :value="item.quantity"
                        :contenteditable="true" :index="index" :subIndex="0" @inputValue="inputValue"></inputDiv>
            </li>
            <li v-for="(subItem,i) in update.col.data.probability"
                :style="{'width':100/nav.length+'%'}">
              <inputDiv :value="subItem.percents[index].percent"
                        :contenteditable="update.updateModel.userLevel.includes(subItem.userLevel)"
                        :index="index" :subIndex="i" @inputValue="inputValueOther"></inputDiv>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else-if="update.updateModel.type==1" class="layout">
      <el-form>
        <el-form-item label="骰子兑换">
          <el-input v-model="update.col.data.exchangeConsumption"></el-input>
        </el-form-item>
        <el-form-item label="条件设置">
          <el-button type="primary" size="small" @click="addData(0)">增加条件</el-button>
          <el-button type="primary" size="small" @click="delData(0)">删除条件</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <div class="item">
          <ul>
            <li v-for="item in navArr" :style="{'width':100/navArr.length+'%'}"><p>{{ item.name }}</p></li>
          </ul>
        </div>
        <div class="item" v-if="update.col.data.limitedDices">
          <ul v-for="(item,index) in update.col.data.limitedDices">
            <li :style="{'width':100/navArr.length+'%'}"><p>{{ index + 1 }}</p></li>
            <li :style="{'width':100/navArr.length+'%'}">
              <span @click="changeTask(-1,index)">{{findTaskName(update.col.limitTaskData,item.taskId)}}<i></i></span>
              <ul class="select" v-if="item.isShow">
                <li v-for="arr in update.col.limitTaskData"
                    :class="[{'checked ':item.taskId==arr.taskId},{'disabled':arr.disabled}]"
                    @click="changeTask(arr,index)">{{arr.taskName}}</li>
              </ul>
            </li>
            <li :style="{'width':100/navArr.length+'%'}"><p>{{item.quantity?item.quantity:'--'}}</p></li>
            <li :style="{'width':100/navArr.length+'%'}">
              <inputDiv :value="item.diceNumber" :contenteditable="true" :index="index"
                        @inputValue="inputValue"></inputDiv>
            </li>
          </ul>
        </div>
      </div>
      <el-form>
        <el-form-item label="奖励设置">
          <el-button type="primary" size="small" @click="addData(1)">增加奖励</el-button>
          <el-button type="primary" size="small" @click="delData(1)">删除奖励</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <div class="item">
          <ul>
            <li v-for="item in nav" :style="{'width':100/nav.length+'%'}"><p>{{ item.name }}</p></li>
          </ul>
        </div>
        <div class="item" v-if="update.col.data.levelQuantities">
          <ul v-for="(item,index) in update.col.data.levelQuantities">
            <li :style="{'width':100/nav.length+'%'}"><p>{{ index + 1 }}</p></li>
            <li :style="{'width':100/nav.length+'%'}">
              <inputDiv :value="item.quantity" :contenteditable="true" :index="index"
                        @inputValue="inputValueOther"></inputDiv>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else-if="update.updateModel.type==2" class="layout">
      <el-form>
        <el-form-item label="关卡设置">
          <el-button type="primary" size="small" @click="addData">增加关卡</el-button>
          <el-button type="primary" size="small" @click="delData">删除关卡</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <div class="item">
          <ul>
            <li v-for="item in navArr" :style="{'width':100/navArr.length+'%'}"><p>{{ item.name }}</p></li>
          </ul>
        </div>
        <div class="item" v-if="update.col.data.levelsQuantity">
          <ul v-for="(item,index) in update.col.data.levelsQuantity">
            <li :style="{'width':100/navArr.length+'%'}"><p>{{ item.level }}</p></li>
            <li :style="{'width':100/navArr.length+'%'}">
              <span @click="changeTask(-1,index)">{{findTaskName(update.col.limitTaskData,item.taskId)}}<i></i></span>
              <ul class="select" v-if="item.isShow">
                <li v-for="arr in update.col.limitTaskData"
                    :class="[{'checked ':item.taskId==arr.taskId},{'disabled':arr.disabled}]"
                    @click="changeTask(arr,index)">{{arr.taskName}}</li>
              </ul>
            </li>
            <li :style="{'width':100/navArr.length+'%'}"><p>{{item.quantity}}</p></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputDiv from '@/views/crs/quantitytask/activity/components/inputDiv'

export default {
  name: 'slotTable',
  components: { inputDiv },
  props: ['update'],
  data() {
    return {
      levelData: [
        { id: 'MIN', name: '迷你' },
        { id: 'STD', name: '标准' },
        { id: 'PLA', name: '铂金' },
        { id: 'ZER', name: '巴菲特' }
      ],
      typeArr: { 0: '奖励', 1: '条件', 2: '关卡' },
      navModel: [{ name: '关卡' }, { name: '限时任务' }, { name: '积分奖励' }],
      inputData: {},
    }
  },
  computed: {
    nav: {
      get() {
        if (this.update.updateModel.type == 0) {
          for (const i in this.update.col.data.probability) {
            if (!this.update.updateModel.userLevel.includes(this.update.col.data.probability[i].userLevel)) {
              this.update.col.data.probability[i].percents.forEach(e => {
                e.percent = 0
              })
            }
          }
          let nav = [{ name: '序号' }, { name: '积分奖励' }], newNav = []
          for (const i in this.levelData) {
            newNav.push({
              name: this.levelData[i].name + '中奖概率（%）'
            })
          }
          nav = nav.concat(newNav)
          return nav
        } else if (this.update.updateModel.type == 1) {
          let nav = [{ name: '关卡' }, { name: '积分奖励' }]
          return nav
        }
      }
    },
    navArr: {
      get() {
        if (this.update.updateModel.type == 1) {
          for (const i in this.update.col.data.limitedDices) {
            this.update.col.data.limitedDices[i].isShow = false
          }
          let nav = this.navModel, newNav = [{ name: '完成后可兑换骰子数' }]
          nav = nav.concat(newNav)
          return nav
        }else if (this.update.updateModel.type == 2){
          for (const i in this.update.col.data.levelsQuantity) {
            this.update.col.data.levelsQuantity[i].isShow = false
          }
          return this.navModel
        }
      }
    }
  },
  methods: {
    findTaskName(data, taskId) {
      let name = '--'
      for (const i in data){
        if (data[i].taskId == taskId) name = data[i].taskName
      }
      return name
    },
    inputValue(option) {
      if (this.update.updateModel.type == 0) {
        let data = JSON.parse(JSON.stringify(this.update.col.data.probability))
        // data[option.subIndex].percents[option.index].quantity = option.value
        for (const i in data) {
          for (const j in data[i].percents) {
            data[i].percents[j].quantity = data[0].percents[j].quantity
            if (j == option.index) {
              data[i].percents[j].quantity = option.value
            }
          }
        }
        this.update.col.data.probability = data
      } else if (this.update.updateModel.type == 1) {
        this.update.col.data.limitedDices[option.index].diceNumber = option.value
      }
    },
    inputValueOther(option) {
      if (this.update.updateModel.type == 0) {
        let data = JSON.parse(JSON.stringify(this.update.col.data.probability))
        data[option.subIndex].percents[option.index].percent = option.value
        this.update.col.data.probability = data
      } else if (this.update.updateModel.type == 1) {
        this.update.col.data.levelQuantities[option.index].quantity = option.value
      }
    },
    addData(type) {
      let num = 0, data = []
      if (!this.update.col.data.probability) this.update.col.data.probability = []
      if (!this.update.col.data.limitedDices) this.update.col.data.limitedDices = []
      if (!this.update.col.data.levelQuantities) this.update.col.data.levelQuantities = []
      if (!this.update.col.data.levelsQuantity) this.update.col.data.levelsQuantity = []
      if (this.update.updateModel.type == 0) {
        data = this.update.col.data.probability
      } else if (this.update.updateModel.type == 1) {
        if (type == 0) {
          data = this.update.col.data.limitedDices
        } else if (type == 1) {
          data = this.update.col.data.levelQuantities
        }
      } else if (this.update.updateModel.type == 2) {
        data = this.update.col.data.levelsQuantity
      }
      if (data.length == 0) {
        num = this.update.col.num
      } else {
        if (this.update.updateModel.type == 0) {
          num = data[0].percents.length
        } else if (this.update.updateModel.type == 1) {
          num = data.length
        } else if (this.update.updateModel.type == 2) {
          num = Number(this.update.col.data.levelsQuantity[this.update.col.data.levelsQuantity.length - 1].level)
        }
      }
      num++
      if (this.update.updateModel.type == 0) {
        let percents = [], flag = false
        var levelLen = this.update.updateModel.userLevel.length
        if (levelLen > 0) {
          flag = true
        }
        if (data.length == 0) {
          if (flag) {
            for (let i = 0; i < 4; i++) {
              data.push({ percents: [] })
              data[i].userLevel = this.levelData[i].id
              data[i].percents = [{
                percent: 0,
                quantity: 0,
                id: num
              }]
            }
            this.update.col.data.probability = data
          } else {
            for (const i in this.levelData) {
              data.push({
                userLevel: this.levelData[i].id,
                percents: [{
                  percent: 0,
                  quantity: 0,
                  id: num
                }]
              })
            }
            this.update.col.data.probability = data
          }
        } else {
          if (flag) {
            let percentsLen = data[0].percents.length
            for (let i = percentsLen; i < num; i++) {
              percents.push({
                percent: 0,
                quantity: 0,
                id: i + 1
              })
            }
            for (let j = 0; j < 4; j++) {
              data[j].userLevel = this.levelData[j].id
              data[j].percents = data[j].percents.concat(percents)
            }
            this.update.col.data.probability = data
          } else {
            for (let i = 0; i < num; i++) {
              percents.push({
                percent: 0,
                quantity: 0,
                id: i + 1
              })
            }
            for (let j = 0; j < 4; j++) {
              data[j].userLevel = this.levelData[j].id
              data[j].percents = percents
            }
            this.update.col.data.probability = data
          }
        }
      } else if (this.update.updateModel.type == 1) {
        this.update.col.data.exchangeConsumption = 0
        if (type == 0) {
          data.push({ taskId: '', quantity: 0, diceNumber: 0 })
          this.update.col.data.limitedDices = data
        } else if (type == 1) {
          data.push({ quantity: 0 })
          this.update.col.data.levelQuantities = data
        }
      } else if (this.update.updateModel.type == 2) {
        data.push({ level: num, taskId: '', quantity: 0 })
        this.update.col.data.levelsQuantity = data
      }
      this.$forceUpdate()
    },
    delData(type) {
      let index = 0, num = 0, data = []
      if (this.update.updateModel.type == 0) {
        data = this.update.col.data.probability
        index = data[0].percents.length - 1
      } else if (this.update.updateModel.type == 1) {
        if (type == 0) {
          data = this.update.col.data.limitedDices
          index = data.length - 1
        } else if (type == 1) {
          data = this.update.col.data.levelQuantities
          index = data.length - 1
        }
      } else if (this.update.updateModel.type == 2) {
        data = this.update.col.data.levelsQuantity
        index = data.length - 1
      }
      if (index > 0) {
        num = index
        if (this.update.updateModel.type == 0) {
          for (const i in data) {
            data[i].percents.splice(index, 1)
          }
        } else {
          data.splice(index, 1)
        }
      }
      if (this.update.updateModel.type == 0) {
        this.update.col.data.probability = data
      } else if (this.update.updateModel.type == 1) {
        if (type == 0) {
          this.update.col.data.limitedDices = data
        } else if (type == 1) {
          this.update.col.data.levelQuantities = data
        }
      } else if (this.update.updateModel.type == 2) {
        this.update.col.data.levelsQuantity = data
      }
      this.$forceUpdate()
    },
    changeTask(obj,index) {
      let flag = false, taskData = [], data = []
      taskData = JSON.parse(JSON.stringify(this.update.col.limitTaskData))
      if (this.update.updateModel.type == 1) {
        data = this.update.col.data.limitedDices
      } else if (this.update.updateModel.type == 2) {
        data = this.update.col.data.levelsQuantity
      }
      if (obj == -1) {
        data[index].isShow = !data[index].isShow
        taskData.forEach(e => {
          for (const i in data) {
            if (e.taskId == data[i].taskId) e.disabled = true
          }
        })
        this.update.col.limitTaskData = taskData
      } else {
        data[index].isShow = false
        taskData.forEach(e => {
          if (e.taskId == obj.taskId) e.disabled = !flag
        })
        this.update.col.limitTaskData = taskData
        for (const i in data) {
          if (data[i].taskId == obj.taskId) {
            this.$message.error('不可选择重复任务！')
            flag = true
          }
        }
        if (!flag) {
          data[index].taskId = obj.taskId
          data[index].quantity = obj.quantity
        }
      }
      if (this.update.updateModel.type == 1) {
        this.update.col.data.limitedDices = data
      } else if (this.update.updateModel.type == 2) {
        this.update.col.data.levelsQuantity = data
      }
      this.$forceUpdate()
    },
  },
}
</script>

<style>
.slotTable .table {
  border: solid 1px #ddd;
  border-bottom: none;
  margin: 10px 0 30px;
}
.slotTable .table .item:first-child{
  background: #f7f7f7;
}
.slotTable .table ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: solid 1px #ddd;
}
.slotTable .table li {
  border-right: solid 1px #ddd;
  list-style: none;
  position: relative;
}
.slotTable .table li:last-child {
  border-right: none;
}
.slotTable .table li p,
.slotTable .table li span,
.slotTable .table li .inputDiv {
  overflow: hidden;
  display: block;
  font-size: 14px;
  color: #606266;
  padding: 0 10px;
  line-height: 40px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  position: relative;
}
.slotTable .table li input {
  width: 100%;
  border: none;
  background: transparent;
  resize: none;
  outline: none;
  text-align: center;
}
.slotTable .table li input::placeholder,
.slotTable .table li input::-webkit-input-placeholder {
  color: #999;
  font-size: 14px;
  text-align: center;
  background: transparent;
  outline: none;
  resize: none;
}
.slotTable .table li input:-webkit-autofill,
.slotTable .table li input:-webkit-autofill:hover,
.slotTable .table li input:-webkit-autofill:focus {
  -webkit-text-fill-color: #333 !important;
  -webkit-box-shadow: inset 0 0 0 1000px #fff !important;
  box-shadow: inset 0 0 0 1000px #fff !important;
  outline: none;
  resize: none;
  text-align: center;
}
.slotTable .table li span{
  cursor: pointer;
}
.slotTable .table li span i{
  position: absolute;
  right: 10px;
  top: 14px;
  background: url("../../../../../assets/arrow.png") no-repeat;
  background-size: 100% 100%;
  width: 9px;
  height: 6px;
  display: block;
}
.slotTable .table li .select{
  display: block;
  width: 100%;
  background: #fff;
  top: 40px;
  left: 0;
  position: absolute;
  z-index: 1001;
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 5px 0;
}
.slotTable .table li .select::before{
  content: "";
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  top: -16px;
  border-bottom: 8px solid #fff;
  border-right: 6px solid rgba(0, 0, 0, 0);
  border-top: 8px solid rgba(0, 0, 0, 0);
  border-left: 6px solid rgba(0, 0, 0, 0);
}
.slotTable .table li .select li{
  overflow: hidden;
  border: none;
  border-bottom: solid 1px #ddd;
  text-align: center;
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #606266;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
.slotTable .table li .select li:last-child{border-bottom: none}
.slotTable .table li .select li:hover,
.slotTable .table li .select li.checked{
  background: #F5F7FA;
}
.slotTable .table li .select li.disabled{
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
}
</style>
